import store from "./store/store";
import { setFeatureFlags } from "./store/features/flags";

export const initializeFeatureFlags = () => {
    store.dispatch(setFeatureFlags());
}